// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___1rpzX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Footer.less
// module id = 713
// module chunks = 37